// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Tz1F","delimiter":"styles_delimiter__zRs7s","branch":"styles_branch__2eebS"};